import {useEffect} from 'react';

export const ErrorRaiser = () => {
  useEffect(() => {
    throw new Error(`Throw error to test application`);
  }, []);

  return null;
};
